import * as types from '@/store/mutation-types'

export default {
    [types.SET_ALL_SIGNAGE_DEVICES](state, devices) {
        state.allDevices = devices
    },
    [types.SET_ALL_SIGNAGE_DEVICES_PAGED_WITH_L0CATIONS](state, devices) {
        state.allDevicesPagedWithLocations = devices
    },
    [types.SET_BEACON_LOGS](state, logs) {
        state.beaconLogs = logs
    },
    [types.SET_DEVICES_SUMMARY](state, summary) {
        state.devicesSummary = summary
    },
    [types.SET_DEVICES_CAMPAIGN](state, campaigns) {
        state.devicesCampaigns = campaigns
    },
    [types.SET_DEVICES_REQUESTS](state, requests) {
        state.requestsByDevice = requests
    },
    [types.SET_DEVICES_STATUS_LOGS](state, logs) {
        state.devicesStatusLogs = logs
    },
    [types.SET_RECENTLY_GENERATED_REPORTS](state, reports) {
        state.recentReports = reports
    }
}
